import React from 'react';
import {Helmet} from 'react-helmet';
import {useLocation} from 'react-router';
import {useApplicationRootUrl} from 'common/component/ApplicationRootContext';
import {pageTitle} from '../domain/pageTitle';

/** Names the browser tab after the page the user is on, so a tab among many says where it leads. */
export const ProviderPageTitle = () => {
    const rootUrl = useApplicationRootUrl();
    const {pathname} = useLocation();
    const path = pathname.startsWith(rootUrl) ? pathname.slice(rootUrl.length) : pathname;
    return (
        <Helmet>
            <title>{pageTitle(path)}</title>
        </Helmet>
    );
};
